<div id="containerOfMain"  class="d-flex h-100 text-center " >
<app-main-screen/>
</div>

